module.exports = __webpack_public_path__ + "img/065-azores islands.801de342.svg";